import React from 'react';
import './Ecosystem.css';

const STEPS = [
  {
    icon: '🏭',
    title: 'Industry Needs',
    desc: 'Real-world challenges & skill requirements',
    color: 'navy',
  },
  {
    icon: '🎓',
    title: 'Academic Learning',
    desc: 'Concepts, fundamentals & domain knowledge',
    color: 'blue',
  },
  {
    icon: '🤝',
    title: 'IIA Training',
    desc: 'Practical learning, tools, simulations & projects',
    color: 'orange',
  },
  {
    icon: '👥',
    title: 'Industry Exposure',
    desc: 'Mentorship, internships & live projects',
    color: 'purple',
  },
  {
    icon: '💼',
    title: 'Industry-Ready Engineers',
    desc: 'Careers that make an impact',
    color: 'green',
  },
];

export default function Ecosystem() {
  return (
    <section className="ecosystem">
      <div className="container ecosystem-inner">
        <div className="ecosystem-header">
          <span className="eyebrow">OUR ECOSYSTEM</span>
          <h2 className="section-title">
            Where <span className="text-blueys">Industry</span>, Academia &amp;{' '}
            <span className="text-orange">Talent</span> Converge
          </h2>
          <p className="section-sub" style={{ margin: '0 auto' }}>
            IIA connects industry requirements with academic learning to develop skilled,
            confident and industry-ready engineers for the future.
          </p>
        </div>

        <div className="ecosystem-flow">
          {STEPS.map((step, i) => (
            <React.Fragment key={step.title}>
              <div className={`ecosystem-step color-${step.color}`}>
                <div className="step-icon">{step.icon}</div>
                <h3>{step.title}</h3>
                <p>{step.desc}</p>
              </div>
              {i < STEPS.length - 1 && <span className="ecosystem-arrow">→</span>}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
}